import { Link } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useState } from "react";
import { motion } from "framer-motion";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { toast } = useToast();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    const origin = window.location.origin;
    const isPreview = origin.includes("id-preview--");
    const envUrl = (import.meta.env.VITE_APP_URL as string | undefined)?.trim();
    const baseUrl = (isPreview ? origin : (envUrl || origin)).replace(/\/$/, "");
    const redirectUrl = `${baseUrl}/reset-password`;
    await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: redirectUrl,
    });
    setSubmitting(false);
    toast({ title: "Email enviado!", description: "Verifique sua caixa de entrada para redefinir a senha." });
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background px-6 py-8 md:p-4">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md">
        <div className="text-center mb-6 md:mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 md:w-14 md:h-14 rounded-2xl gradient-primary mb-4">
            <Lock className="w-8 h-8 md:w-7 md:h-7 text-primary-foreground" />
          </div>
          <h1 className="text-2xl font-bold text-foreground">Recuperar Senha</h1>
          <p className="text-base md:text-sm text-muted-foreground mt-1">Enviaremos um link para seu email</p>
        </div>

        <div className="bg-card rounded-2xl p-6 shadow-card border border-border">
          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="space-y-2">
              <Label htmlFor="email" className="text-base md:text-sm">Email</Label>
              <Input id="email" type="email" placeholder="seu@email.com" value={email} onChange={e => setEmail(e.target.value)} className="h-[52px] text-base md:h-10 md:text-sm" />
            </div>
            <Button type="submit" disabled={submitting} className="w-full h-[52px] md:h-10 text-base md:text-sm font-semibold gradient-primary text-primary-foreground hover:opacity-90 transition-opacity">
              {submitting ? <Loader2 className="w-5 h-5 animate-spin mr-2" /> : null}
              Enviar link
            </Button>
          </form>
          <div className="mt-5 text-center text-base md:text-sm text-muted-foreground">
            <Link to="/login" className="text-primary hover:underline">Voltar ao login</Link>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default ForgotPassword;
